import { render, staticRenderFns } from "./HeaderCollection.vue?vue&type=template&id=25f58933&lang=pug&"
import script from "./HeaderCollection.vue?vue&type=script&lang=js&"
export * from "./HeaderCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports